import { cn } from "@/lib/cn";

/**
 * Plug Me wordmark + mark. Original SVG glyph — a rounded tile with an
 * upward "service spark" formed from a checkmark, signaling done & trusted.
 */
export function Logo({
  className,
  showWordmark = true,
  light = false,
}: {
  className?: string;
  showWordmark?: boolean;
  /** Use a light wordmark on dark backgrounds (e.g. the footer). */
  light?: boolean;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <svg
        viewBox="0 0 32 32"
        role="img"
        aria-label="Plug Me"
        className="h-8 w-8 shrink-0"
      >
        <defs>
          <linearGradient id="servio-mark" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#12b27d" />
            <stop offset="100%" stopColor="#0b7c57" />
          </linearGradient>
        </defs>
        <rect width="32" height="32" rx="9" fill="url(#servio-mark)" />
        <path
          d="M9 16.5l4.2 4.2L23 11.5"
          fill="none"
          stroke="#ffffff"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="23.2" cy="11.2" r="1.7" fill="#f5a524" />
      </svg>
      {showWordmark && (
        <span
          className={cn(
            "text-xl font-bold tracking-tight",
            light ? "text-white" : "text-ink",
          )}
        >
          Plug Me
        </span>
      )}
    </span>
  );
}
